import React from 'react';
import {useSearchParams} from 'react-router-dom';
import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {SidebarLinkModuleCustomization} from 'src/app/layout/Sidebar/SidebarLinksConfig';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {useUrlQueryTabV2} from 'src/shared/hooks/useUrlQueryTabV2';
import {ModulesTab} from './components/ModulesTab';
import {InstanceSettingsTab} from './components/InstanceSettingsTab';

type ModuleCustomizationView = 'modules' | 'settings';

const ModuleCustomizationListPage: React.FC = () => {
  useSetDocumentTitle('Module Customization');
  const [searchParams, setSearchParams] = useSearchParams();
  const activeView =
    (searchParams.get('view') as ModuleCustomizationView) || 'modules';

  const {RenderedTabsComponent} = useUrlQueryTabV2<ModuleCustomizationView>({
    view: activeView,
    defaultView: 'modules',
    tabs: [
      {view: 'modules', label: 'Modules', component: <ModulesTab />},
      {view: 'settings', label: 'Settings', component: <InstanceSettingsTab />},
    ],
    onSelectView: nextView => {
      setSearchParams(
        previous => {
          const next = new URLSearchParams(previous);
          next.set('view', nextView);
          return next;
        },
        {replace: true}
      );
    },
  });

  return (
    <ContentWrapper>
      <PageHeader>
        <PageHeader.Title
          icon={SidebarLinkModuleCustomization.icon}
          subtitle="Configure extension tabs and customizations for modules">
          Module Customization
        </PageHeader.Title>
      </PageHeader>
      {RenderedTabsComponent}
    </ContentWrapper>
  );
};

export default ModuleCustomizationListPage;

routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.ModuleCustomization(),
  element: <ModuleCustomizationListPage />,
  module: ModuleEnum.ModuleExtensions,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});
